module.exports = __webpack_public_path__ + "img/IMG_9824-1200w.fb9f79aa.jpg";